// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { api } from "../services/api";

// export const fetchTransactions = createAsyncThunk(
//   "transactions/fetch",
//   async ({ projectId, params }, { rejectWithValue }) => {
//     try {
//       const { data } = await api.get(`/projects/${projectId}/transactions`, { params });
//       return data; // {items, total, page, limit, summary}
//     } catch (err) {
//       return rejectWithValue(err?.response?.data?.message || "Failed to load transactions");
//     }
//   }
// );

// export const fetchTransactionsDropdown = createAsyncThunk(
//   "transactions/fetch/dropdown",
//   async ({ projectId, params }, { rejectWithValue }) => {
//     try {
//       const { data } = await api.get(`/projects/${projectId}/transactions/list`, { params });
//       return data; // {items, total, page, limit, summary}
//     } catch (err) {
//       return rejectWithValue(err?.response?.data?.message || "Failed to load transactions");
//     }
//   }
// );











// export const createTransaction = createAsyncThunk(
//   "transactions/create",
//   async ({ projectId, body }, { rejectWithValue }) => {
//     try {
//       const { data } = await api.post(`/projects/${projectId}/transactions`, body);
//       return data.tx;
//     } catch (err) {
//       return rejectWithValue(err?.response?.data?.message || "Failed to create transaction");
//     }
//   }
// );

// export const updateTransaction = createAsyncThunk(
//   "transactions/update",
//   async ({ projectId, id, body }, { rejectWithValue }) => {
//     try {
//       const { data } = await api.put(`/projects/${projectId}/transactions/${id}`, body);
//       return data.tx;
//     } catch (err) {
//       return rejectWithValue(err?.response?.data?.message || "Failed to update transaction");
//     }
//   }
// );

// export const deleteTransaction = createAsyncThunk(
//   "transactions/delete",
//   async ({ projectId, id }, { rejectWithValue }) => {
//     try {
//       await api.delete(`/projects/${projectId}/transactions/${id}`);
//       return id;
//     } catch (err) {
//       return rejectWithValue(err?.response?.data?.message || "Failed to delete transaction");
//     }
//   }
// );

// const slice = createSlice({
//   name: "transactions",
//   initialState: {
//     items: [],
//     dropdown:[],
//     total: 0,
//     page: 1,
//     limit: 12,
//     summary: {
//       totalAmount: 0,
//       totalPaid: 0,
//       totalRemaining: 0,
//       qty: 0,
//     },
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     resetTransactions(state) {
//       state.items = [];
//       state.total = 0;
//       state.page = 1;
//       state.limit = 12;
//       state.summary = {
//         totalAmount: 0,
//         totalPaid: 0,
//         totalRemaining: 0,
//         qty: 0,
//       };
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (b) => {
//     b.addCase(fetchTransactions.pending, (s) => {
//       s.loading = true;
//       s.error = null;
//     })
//       .addCase(fetchTransactions.fulfilled, (s, a) => {
//         s.loading = false;
//         s.items = a.payload.items;
//         s.total = a.payload.total;
//         s.page = a.payload.page;
//         s.limit = a.payload.limit;
//         s.summary = a.payload.summary || {
//           totalAmount: 0,
//           totalPaid: 0,
//           totalRemaining: 0,
//           qty: 0,
//         }; // Update summary in the state
//       })
//       .addCase(fetchTransactions.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload;
//       })
//       .addCase(createTransaction.fulfilled, (s, a) => {
//         s.items = [a.payload, ...s.items];
//         s.total += 1;
//       })
//       .addCase(updateTransaction.fulfilled, (s, a) => {
//         s.items = s.items.map((t) => (t._id === a.payload._id ? a.payload : t));
//       })
//       .addCase(deleteTransaction.fulfilled, (s, a) => {
//         s.items = s.items.filter((t) => t._id !== a.payload);
//         s.total = Math.max(s.total - 1, 0);
//       });
//   },
// });

// export const { resetTransactions } = slice.actions;
// export default slice.reducer;


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api";

// Fetch transactions
export const fetchTransactions = createAsyncThunk(
  "transactions/fetch",
  async ({ projectId, params }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/projects/${projectId}/transactions`, { params });
      return data; // {items, total, page, limit, summary}
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to load transactions");
    }
  }
);

// Fetch dropdown items for transactions
export const fetchTransactionsDropdown = createAsyncThunk(
  "transactions/list",
  async ({ projectId, params }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/projects/${projectId}/transactions`, { params });
      return data; // {items, total, page, limit, summary}
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to load transactions dropdown");
    }
  }
);

// Create a new transaction
export const createTransaction = createAsyncThunk(
  "transactions/create",
  async ({ projectId, body }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/projects/${projectId}/transactions`, body);
      return data.tx; // Return the created transaction
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to create transaction");
    }
  }
);

// Update an existing transaction
export const updateTransaction = createAsyncThunk(
  "transactions/update",
  async ({ projectId, id, body }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/projects/${projectId}/transactions/${id}`, body);
      return data.tx; // Return the updated transaction
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to update transaction");
    }
  }
);

// Delete a transaction
export const deleteTransaction = createAsyncThunk(
  "transactions/delete",
  async ({ projectId, id }, { rejectWithValue }) => {
    try {
      await api.delete(`/projects/${projectId}/transactions/${id}`);
      return id; // Return the id of the deleted transaction
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to delete transaction");
    }
  }
);

// Redux slice
const slice = createSlice({
  name: "transactions",
  initialState: {
    items: [], // All transactions
    dropdown: [], // Dropdown options for transactions
    total: 0, // Total number of transactions
    page: 1, // Current page for pagination
    limit: 12, // Items per page
    summary: {
      totalAmount: 0,
      totalPaid: 0,
      totalRemaining: 0,
      qty: 0,
    },
    loading: false, // Loading state for async actions
    error: null, // Error state for async actions
  },
  reducers: {
    resetTransactions(state) {
      state.items = [];
      state.total = 0;
      state.page = 1;
      state.limit = 12;
      state.summary = {
        totalAmount: 0,
        totalPaid: 0,
        totalRemaining: 0,
        qty: 0,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Transactions
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
        state.summary = action.payload.summary || {
          totalAmount: 0,
          totalPaid: 0,
          totalRemaining: 0,
          qty: 0,
        };
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Transactions Dropdown
      .addCase(fetchTransactionsDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactionsDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.dropdown = action.payload.items || []; // Fill dropdown with fetched items
      })
      .addCase(fetchTransactionsDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Transaction
      .addCase(createTransaction.fulfilled, (state, action) => {
        state.items = [action.payload, ...state.items];
        state.total += 1;
      })

      // Update Transaction
      .addCase(updateTransaction.fulfilled, (state, action) => {
        state.items = state.items.map((transaction) =>
          transaction._id === action.payload._id ? action.payload : transaction
        );
      })

      // Delete Transaction
      .addCase(deleteTransaction.fulfilled, (state, action) => {
        state.items = state.items.filter((transaction) => transaction._id !== action.payload);
        state.total = Math.max(state.total - 1, 0);
      });
  },
});

// Actions and Reducer export
export const { resetTransactions } = slice.actions;
export default slice.reducer;